<template>
  <v-container fluid>
    <div v-if="loading">
      <v-skeleton-loader type="list-item-avatar, list-item-three-line, actions" class="mb-3"></v-skeleton-loader>
      <v-skeleton-loader type="table"></v-skeleton-loader>
    </div>
    <div v-else>
      <div class="text-h1 mb-4">
        Concessionárias
      </div>
      <v-data-table
        :headers="headers"
        :items="dados"
        :search="searchFinal"
        multi-sort
        class="elevation-1 base_table"
        :footer-props="{
          itemsPerPageOptions: [5,10,15,20,25,50,100],
          showFirstLastPage: true,
          firstIcon: 'skip_previous',
          lastIcon: 'skip_next',
          prevIcon: 'chevron_left',
          nextIcon: 'chevron_right'
        }"
        :header-props="{
          sortIcon: 'north',
        }"
      >
        <template v-slot:top>
          <v-row no-gutters align="center" justify="space-between">
            <div class="py-2 px-2">
              <v-row no-gutters>
                <v-form @submit.prevent="buscaItens()">
                  <v-text-field
                    clearable
                    hide-details=""
                    clear-icon="close"
                    v-model="search"
                    outlined
                    label="Busca"
                    @click:clear="limparBusca()"
                  ></v-text-field>
                </v-form>
                <v-autocomplete
                  class="ml-3"
                  :menu-props="{ offsetY: true}"
                  :items="estados"
                  label="Estado"
                  append-icon="expand_more"
                  v-model="estado"
                  hide-details=""
                  :loading="loading || loadingEstados"
                  :disabled="loading || loadingEstados"
                  outlined
                  @click:clear="applyFilter()"
                  clearable
                  clear-icon="close"
                  @change="filterCidade()"
                ></v-autocomplete>
                <v-autocomplete
                  class="ml-3"
                  :menu-props="{ offsetY: true}"
                  :items="cidadesFiltro"
                  label="Cidade"
                  append-icon="expand_more"
                  v-model="cidade"
                  hide-details=""
                  :loading="loading || loadingCidades"
                  :disabled="loading || loadingCidades"
                  outlined
                  @click:clear="applyFilter()"
                  clearable
                  clear-icon="close"
                  @change="applyFilter()"
                ></v-autocomplete>
              </v-row>
            </div>
            <div>
              <v-menu
                bottom
                center
                offset-y
                max-height="400"
              >
                <template v-slot:activator="{ on, attrs }">
                  <div v-bind="attrs" v-on="on">
                    Exportar
                    <v-icon>arrow_drop_down</v-icon>
                  </div>
                </template>
                <v-list>
                  <v-list-item @click="exportXls()">
                    <v-list-item-icon class="mr-1">
                      <v-icon color="primary">receipt_long</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>Exportar para XLS</v-list-item-title>
                  </v-list-item>
                  <!-- <v-list-item @click="exportPdf()">
                    <v-list-item-icon class="mr-1">
                      <v-icon color="primary">assignment</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>Exportar para PDF</v-list-item-title>
                  </v-list-item> -->
                </v-list>
              </v-menu>
            </div>
          </v-row>
        </template>
        <template v-slot:item.con_cnpj="{ item }">
          {{item.con_cnpj | VMask('###.###.###-##')}}
        </template>
        <template v-slot:item.base_tarifaria="{ item }">
          <v-icon v-bind="attrs" v-on="on" @click="openBaseTarifaria(item)" color="primary" class="mr-2">
            attach_money
          </v-icon>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-row no-gutters align="center" justify="center">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon v-bind="attrs" v-on="on" @click="openNovo(item)" color="primary" class="mr-2">
                  edit
                </v-icon>
              </template>
              <span>Editar</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon v-bind="attrs" v-on="on" @click="openDialogDelete(item)" color="primary" class="ml-2">
                  delete
                </v-icon>
              </template>
              <span>Excluir</span>
            </v-tooltip>
          </v-row>
        </template>
      </v-data-table>
    </div>
    <div class="ui-create" v-if="nivelUsuarioApelido === 'M' || nivelUsuarioApelido === 'D'">
      <v-btn color="primary" elevation="3" @click="dialogNovo = true" :loading="loading" :disabled="loading">
        <v-icon color="white" x-large>add</v-icon>
      </v-btn>
    </div>
    <v-dialog
      v-model="dialogNovo"
      persistent
      max-width="500px"
    >
      <v-card class="ui-dialog-top">
        <v-row align="center" justify="space-between">
          <v-col cols="10">
            {{concessionaria.uuid_con_id ? 'Editar' : 'Nova'}} concessionária
          </v-col>
          <v-col cols="2" class="text-right">
            <v-icon @click="closeDialog()">close</v-icon>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="ui-dialog-content">
        <v-form ref="formConcessionaria">
          <v-row>
            <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="pb-0">
              <v-text-field
                v-model="concessionaria.con_nome"
                autofocus
                label="Nome*"
                :rules="[rules.required]"
                outlined
                :disabled="salvando"
                :loading="salvando"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="pt-0 pb-0">
              <v-text-field-cnpj
                outlined
                label="CNPJ*"
                required=""
                :rules="[rules.required]"
                v-model="concessionaria.con_cnpj"
                v-bind:properties="{
                  readonly: false,
                  disabled: salvando,
                  outlined: true,
                  clearable: true,
                  placeholder: '',
                  loading: salvando
                }"
                v-bind:options="{
                  outputMask: '##############',
                  empty: null,
                  applyAfter: false,
                }"
              ></v-text-field-cnpj>
            </v-col>
            <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="pt-0 pb-0">
              <v-autocomplete
                v-model="concessionaria.con_uf"
                autocomplete="off"
                :rules="[rules.required]"
                :items="estados"
                :loading="salvando || loadingEstados"
                :disabled="salvando || loadingEstados"
                label="Estado*"
                append-icon="expand_more"
                outlined
                @change="filterCidadeCadastro(concessionaria.con_uf)"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="pt-0">
              <v-combobox
                autocomplete="off"
                v-model="concessionaria.cidades"
                :menu-props="{ offsetY: true}"
                :items="cidadesCadastro"
                hide-selected
                label="Cidades"
                multiple
                clear-icon="close"
                append-icon="expand_more"
                :loading="salvando || loadingCidadesCadastro"
                :disabled="salvando || loadingCidadesCadastro"
                outlined
                small-chips
              >
                <template v-slot:selection="{ attrs, item, parent, selected }">
                  <v-chip
                    v-bind="attrs"
                    :input-value="selected"
                    v-if="item.text"
                    label
                    small
                  >
                    <span class="pr-2">
                      {{ item.text }}
                    </span>
                    <v-icon
                      small
                      @click="parent.selectItem(item)"
                    >
                      close
                    </v-icon>
                  </v-chip>
                </template>
              </v-combobox>
            </v-col>
          </v-row>
         </v-form>
        <v-divider></v-divider>
        <v-row no-gutters class="mt-4 mb-0" align="center" justify="space-between">
          <v-btn
            color="cancel"
            :loading="salvando"
            :disabled="salvando"
            @click="closeDialog()"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="primary"
            @click="saveEditConcessionaria()"
            :loading="salvando"
            :disabled="salvando"
          >
            Salvar
          </v-btn>
        </v-row>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogExcluir" max-width="400">
      <v-card class="ui-dialog-top">
        <v-row align="center" justify="space-between">
          <v-col cols="10">
            Excluir Concessionária
          </v-col>
          <v-col cols="2" class="text-right">
            <v-icon @click="cancelarDelete()">close</v-icon>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="ui-dialog-content">
        <div class="text-h3 mb-5">
          Tem certeza que deseja excluir Concessionária <b class="text-primary">{{concessionaria ? concessionaria.con_nome : ''}}</b>?
        </div>
        <v-divider class="mb-3"></v-divider>
        <v-row
          align="center"
          justify="space-between"
          class="px-5 py-5"
        >
          <v-btn
            color="cancel"
            :loading="salvando"
            :disabled="salvando"
            @click="cancelarDelete()"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="success"
            :loading="salvando"
            :disabled="salvando"
            @click="removeConcessionaria()"
          >
            Excluir
          </v-btn>
        </v-row>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialogBaseTarifaria"
      persistent
      max-width="1500px"
    >
      <v-card class="ui-dialog-top">
        <v-row align="center" justify="space-between">
          <v-col cols="10">
            Bases Tarifárias
          </v-col>
          <v-col cols="2" class="text-right">
            <v-icon @click="closeDialogBaseTarifaria()">close</v-icon>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="ui-dialog-content">
        <v-data-table
          :headers="headersBaseTarifaria"
          :items="dadosBaseTarifaria"
          :search="searchFinalBaseTarifaria"
          multi-sort
          class="elevation-1 base_table"
          :footer-props="{
            itemsPerPageOptions: [5,10,15,20,25,50,100],
            showFirstLastPage: true,
            firstIcon: 'skip_previous',
            lastIcon: 'skip_next',
            prevIcon: 'chevron_left',
            nextIcon: 'chevron_right'
          }"
          :header-props="{
            sortIcon: 'north',
          }"
        >
          <template v-slot:top>
            <v-row no-gutters align="center" justify="space-between">
              <div class="py-2 px-2">
                <v-row no-gutters>
                  <v-form @submit.prevent="getBasesTarifarias(concessionariaSelecionada)">
                    <v-text-field
                      clearable
                      hide-details=""
                      clear-icon="close"
                      v-model="searchFinalBaseTarifaria"
                      outlined
                      label="Busca"
                      @click:clear="limparBusca()"
                    ></v-text-field>
                  </v-form>
                  <v-autocomplete
                    class="ml-3"
                    :menu-props="{ offsetY: true}"
                    :items="baseTarifariaEnum"
                    label="Base Tarifária"
                    append-icon="expand_more"
                    v-model="baseTarifariaEnumSelecionada"
                    hide-details=""
                    :loading="loadingBaseTarifaria"
                    :disabled="loadingBaseTarifaria"
                    outlined
                    clearable
                    clear-icon="close"
                    @change="getBasesTarifarias(concessionariaSelecionada)"
                  ></v-autocomplete>
                  <v-autocomplete
                    class="ml-3"
                    :menu-props="{ offsetY: true}"
                    :items="modalidadeEnum"
                    label="Modalidade"
                    append-icon="expand_more"
                    v-model="modalidadeSelecionada"
                    hide-details=""
                    :loading="loadingBaseTarifaria"
                    :disabled="loadingBaseTarifaria"
                    outlined
                    clearable
                    clear-icon="close"
                    @change="getBasesTarifarias(concessionariaSelecionada)"
                  ></v-autocomplete>
                  <v-autocomplete
                    class="ml-3"
                    :menu-props="{ offsetY: true}"
                    :items="classeEnum"
                    label="Classe"
                    append-icon="expand_more"
                    v-model="classeSelecionada"
                    hide-details=""
                    :loading="loadingBaseTarifaria"
                    :disabled="loadingBaseTarifaria"
                    outlined
                    clearable
                    clear-icon="close"
                    @change="getBasesTarifarias(concessionariaSelecionada)"
                  ></v-autocomplete>
                  <v-autocomplete
                    class="ml-3"
                    :menu-props="{ offsetY: true}"
                    :items="postoEnum"
                    label="Posto"
                    append-icon="expand_more"
                    v-model="postoSelecionada"
                    hide-details=""
                    :loading="loadingBaseTarifaria"
                    :disabled="loadingBaseTarifaria"
                    outlined
                    clearable
                    clear-icon="close"
                    @change="getBasesTarifarias(concessionariaSelecionada)"
                  ></v-autocomplete>
                </v-row>
              </div>
            </v-row>
          </template>
          <template v-slot:item.bt_vigencia_inicio="{ item }">
            {{ formatData(item.bt_vigencia_inicio) }}
          </template>
          <template v-slot:item.bt_vigencia_fim="{ item }">
            {{ formatData(item.bt_vigencia_fim) }}
          </template>
          <template v-slot:item.bt_base_tarifaria="{ item }">
            {{ getEnumValue('baseTarifariaEnum', item.bt_base_tarifaria) }}
          </template>
          <template v-slot:item.bt_modalidade="{ item }">
            {{ getEnumValue('modalidadeEnum', item.bt_modalidade) }}
          </template>
          <template v-slot:item.bt_classe="{ item }">
            {{ getEnumValue('classeEnum', item.bt_classe) }}
          </template>
          <template v-slot:item.bt_posto="{ item }">
            {{ getEnumValue('postoEnum', item.bt_posto) }}
          </template>
          <template v-slot:item.bt_valor="{ item }">
            {{ setCurrencyFormat(item.bt_valor) }}
          </template>
          <template v-slot:item.actions="{ item }">
            <v-row no-gutters align="center" justify="center">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon v-bind="attrs" v-on="on" @click="openDialogNovoBaseTarifaria(item)" color="primary">
                    edit
                  </v-icon>
                </template>
                <span>Editar</span>
              </v-tooltip>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon v-bind="attrs" v-on="on" @click="openDialogDeleteBaseTarifaria(item)" color="primary">
                    delete
                  </v-icon>
                </template>
                <span>Excluir</span>
              </v-tooltip>
            </v-row>
          </template>
        </v-data-table>
        <v-divider class="mb-3"></v-divider>
        <v-row
          align="center"
          justify="space-between"
          class="px-5 py-5"
        >
          <v-btn
            color="cancel"
            @click="closeDialogBaseTarifaria()"
          >
            Fechar
          </v-btn>
          <v-btn
            color="primary"
            @click="openDialogNovoBaseTarifaria()"
          >
            Adicionar Base Tarifária
          </v-btn>
        </v-row>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialogNovaBaseTarifaria"
      persistent
      max-width="1000px"
    >
      <v-card class="ui-dialog-top">
        <v-row align="center" justify="space-between">
          <v-col cols="10">
            {{baseTarifariaSelecionada.uuid_bt_id ? 'Editar' : 'Nova'}} base tarifária
          </v-col>
          <v-col cols="2" class="text-right">
            <v-icon @click="closeDialogNovoBaseTarifaria()">close</v-icon>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="ui-dialog-content">
        <v-form ref="formBaseTarifaria">
          <v-row>
            <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="pb-0">
              <v-menu
                ref="calendarDataInicio"
                v-model="calendarDataInicio"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    outlined
                    label="Vigência Inicio*"
                    :rules="[rules.required]"
                    append-icon="calendar_today"
                    :loading="loadingBaseTarifaria"
                    :disabled="loadingBaseTarifaria"
                    v-bind="attrs"
                    v-on="on"
                    v-model="dataFormatadaInicio"
                    v-mask="'##/##/####'"
                    @input="() => {
                      calendarDataInicio = false
                      baseTarifariaSelecionada.bt_vigencia_inicio = $root.Formatter.parseDate(dataFormatadaInicio)
                      updatePickerModalDataInicio = $root.Formatter.parseDate(dataFormatadaInicio)
                    }"
                  ></v-text-field>
                </template>
                <v-date-picker
                  :picker-date.sync="updatePickerModalDataInicio"
                  year-icon="calendar_today"
                  prev-icon="chevron_left"
                  next-icon="chevron_right"
                  :max="baseTarifariaSelecionada.bt_vigencia_fim"
                  :loading="loadingBaseTarifaria"
                  :disabled="loadingBaseTarifaria"
                  v-model="dataInicio"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="pb-0">
              <v-menu
                ref="calendarDataFim"
                v-model="calendarDataFim"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    outlined
                    label="Vigência Fim*"
                    :rules="[rules.required]"
                    append-icon="calendar_today"
                    :loading="loadingBaseTarifaria"
                    :disabled="loadingBaseTarifaria"
                    v-bind="attrs"
                    v-on="on"
                    v-model="dataFormatadaFim"
                    v-mask="'##/##/####'"
                    @input="() => {
                      calendarDataFim = false
                      baseTarifariaSelecionada.bt_vigencia_fim = $root.Formatter.parseDate(dataFormatadaFim)
                      updatePickerModalDataFim = $root.Formatter.parseDate(dataFormatadaFim)
                    }"
                  ></v-text-field>
                </template>
                <v-date-picker
                  :picker-date.sync="updatePickerModalDataFim"
                  year-icon="calendar_today"
                  prev-icon="chevron_left"
                  next-icon="chevron_right"
                  :min="baseTarifariaSelecionada.bt_vigencia_inicio"
                  :loading="loadingBaseTarifaria"
                  :disabled="loadingBaseTarifaria"
                  v-model="dataFim"
                ></v-date-picker>
              </v-menu>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="12" md="6" lg="6" xl="6" class="pb-0">
              <v-autocomplete
                :menu-props="{ offsetY: true}"
                :items="baseTarifariaEnum"
                label="Base Tarifária*"
                :rules="[rules.required]"
                append-icon="expand_more"
                v-model="baseTarifariaSelecionada.bt_base_tarifaria"
                :loading="loadingBaseTarifaria"
                :disabled="loadingBaseTarifaria"
                outlined
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="12" md="6" lg="6" xl="6" class="pb-0">
              <v-text-field
                v-model="baseTarifariaSelecionada.bt_subgrupo"
                label="Subgrupo*"
                :rules="[rules.required]"
                outlined
                :loading="loadingBaseTarifaria"
                :disabled="loadingBaseTarifaria"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="12" md="6" lg="4" xl="4" class="pb-0">
              <v-autocomplete
                :menu-props="{ offsetY: true}"
                :items="modalidadeEnum"
                label="Modalidade*"
                :rules="[rules.required]"
                append-icon="expand_more"
                v-model="baseTarifariaSelecionada.bt_modalidade"
                :loading="loadingBaseTarifaria"
                :disabled="loadingBaseTarifaria"
                outlined
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="12" md="6" lg="4" xl="4" class="pb-0">
              <v-autocomplete
                :menu-props="{ offsetY: true}"
                :items="classeEnum"
                label="Classe"
                append-icon="expand_more"
                v-model="baseTarifariaSelecionada.bt_classe"
                :loading="loadingBaseTarifaria"
                :disabled="loadingBaseTarifaria"
                outlined
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="12" md="6" lg="4" xl="4" class="pb-0">
              <v-text-field
                v-model="baseTarifariaSelecionada.bt_subclasse"
                label="Subclasse"
                outlined
                :loading="loadingBaseTarifaria"
                :disabled="loadingBaseTarifaria"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="6" lg="4" xl="4" class="pb-0">
              <v-text-field
                v-model="baseTarifariaSelecionada.bt_detalhe"
                label="Detalhe"
                outlined
                :loading="loadingBaseTarifaria"
                :disabled="loadingBaseTarifaria"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="6" lg="4" xl="4" class="pb-0">
              <v-text-field
                v-model="baseTarifariaSelecionada.bt_acessante"
                label="Acessante"
                outlined
                :loading="loadingBaseTarifaria"
                :disabled="loadingBaseTarifaria"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="6" lg="4" xl="4" class="pb-0">
              <v-autocomplete
                :menu-props="{ offsetY: true}"
                :items="postoEnum"
                label="Posto"
                append-icon="expand_more"
                v-model="baseTarifariaSelecionada.bt_posto"
                :loading="loadingBaseTarifaria"
                :disabled="loadingBaseTarifaria"
                outlined
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="12" md="6" lg="4" xl="4" class="pb-0">
              <v-text-field
                label="Componente Tarifária"
                outlined
                :loading="loadingBaseTarifaria"
                :disabled="loadingBaseTarifaria"
                v-model="baseTarifariaSelecionada.bt_componente_tarifaria"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="6" lg="4" xl="4" class="pb-0">
              <vuetify-money
                lazy-validation
                v-model="baseTarifariaSelecionada.bt_valor"
                :backgroundColor="$vuetify.theme.dark ? '#1e1e1e00' : '#fff'"
                :loading="loadingBaseTarifaria"
                :disabled="loadingBaseTarifaria"
                outlined
                :options="optionsMoney"
                valueWhenIsEmpty="0,00"
                label="Valor"
                prefix="R$"
              ></vuetify-money>
            </v-col>
          </v-row>
         </v-form>
        <v-divider></v-divider>
        <v-row no-gutters class="mt-4 mb-0" align="center" justify="space-between">
          <v-btn
            color="cancel"
            :loading="salvando"
            :disabled="salvando"
            @click="closeDialogNovoBaseTarifaria()"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="primary"
            @click="saveEditBaseTarifaria()"
            :loading="salvando"
            :disabled="salvando"
          >
            Salvar
          </v-btn>
        </v-row>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogExcluirBaseTarifaria" max-width="400">
      <v-card class="ui-dialog-top">
        <v-row align="center" justify="space-between">
          <v-col cols="10">
            Excluir Base Tarifaria
          </v-col>
          <v-col cols="2" class="text-right">
            <v-icon @click="cancelarDeleteBaseTarifaria()">close</v-icon>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="ui-dialog-content">
        <div class="text-h3 mb-5">
          Tem certeza que deseja excluir Base Tarifária?
        </div>
        <v-divider class="mb-3"></v-divider>
        <v-row
          align="center"
          justify="space-between"
          class="px-5 py-5"
        >
          <v-btn
            color="cancel"
            :loading="salvando"
            :disabled="salvando"
            @click="cancelarDeleteBaseTarifaria()"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="success"
            :loading="salvando"
            :disabled="salvando"
            @click="removeBaseTarifaria()"
          >
            Excluir
          </v-btn>
        </v-row>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import Api from '@API'
import axios from 'axios'
import moment from 'moment'
import RelatorioBase from '@components/impressoes/RelatorioBase.vue'

export default {
  data () {
    return {
      nivelUsuarioApelido: '',
      optionsMoney: {
        locale: 'pt-BR',
        prefix: 'R$',
        suffix: '',
        length: 14,
        precision: 8
      },
      loading: true,
      salvando: false,
      dialogNovo: false,
      dialogExcluir: false,
      dialogBaseTarifaria: false,
      dialogNovaBaseTarifaria: false,
      dialogExcluirBaseTarifaria: false,
      estados: [],
      cidades: [],
      cidadesFiltro: [],
      cidade: null,
      estado: null,
      cidadesFiltradas: [],
      cidadesCadastro: [],
      loadingEstados: false,
      loadingCidades: false,
      loadingCidadesCadastro: false,
      rules: {
        required: value => !!value || 'Obrigatório.'
      },
      search: '',
      searchFinal: '',
      headers: [
        {
          text: 'ID',
          align: 'start',
          value: 'con_id'
        },
        { text: 'Nome', value: 'con_nome' },
        { text: 'CNPJ', value: 'con_cnpj' },
        { text: 'Estado', value: 'con_uf', align: 'center' },
        { text: 'Base Tarifária', value: 'base_tarifaria', align: 'center' }
      ],
      dados: [],
      concessionaria: {
        con_nome: '',
        con_cnpj: '',
        con_uf: ''
      },
      loadingBaseTarifaria: false,
      headersBaseTarifaria: [
        { text: 'Início Vigencia', value: 'bt_vigencia_inicio', align: 'center' },
        { text: 'Fim Vigencia', value: 'bt_vigencia_fim', align: 'center' },
        { text: 'Base Tarifária', value: 'bt_base_tarifaria', align: 'center' },
        { text: 'Subgrupo', value: 'bt_subgrupo', align: 'center' },
        { text: 'Modalidade', value: 'bt_modalidade', align: 'center' },
        { text: 'Classe', value: 'bt_classe', align: 'center' },
        { text: 'Subclasse', value: 'bt_subclasse', align: 'center' },
        { text: 'Detalhe', value: 'bt_detalhe', align: 'center' },
        { text: 'Acessamte', value: 'bt_acessante', align: 'center' },
        { text: 'Posto', value: 'bt_posto', align: 'center' },
        { text: 'Componente Tarifária', value: 'bt_componente_tarifaria', align: 'center' },
        { text: 'Valor', value: 'bt_valor', align: 'center' },
        { text: 'Ações', value: 'actions', align: 'center' }
      ],
      dadosBaseTarifaria: [],
      searchFinalBaseTarifaria: '',
      concessionariaSelecionada: null,
      baseTarifariaSelecionada: {
        uuid_bt_id: '',
        bt_valor: null,
        bt_vigencia_inicio: null,
        bt_vigencia_fim: null,
        bt_base_tarifaria: null,
        bt_subgrupo: null,
        bt_modalidade: null,
        bt_classe: null,
        bt_subclasse: null,
        bt_detalhe: null,
        bt_acessante: null,
        bt_posto: null,
        bt_componente_tarifaria: null,
        uuid_con_id: null
      },
      baseTarifariaEnum: [
        { text: 'Base Tarifária', value: 'BASE_ECONOMICA' },
        { text: 'Tarifa de Aplicação', value: 'APLICACAO' }
      ],
      baseTarifariaEnumSelecionada: '',
      modalidadeEnum: [
        { text: 'Azul', value: 'AZUL' },
        { text: 'Branca', value: 'BRANCA' },
        { text: 'Verde', value: 'VERDE' },
        { text: 'Convencional', value: 'CONVENCIONAL' },
        { text: 'Convencional pré-pagamento', value: 'CONVENCIONAL_PRE_PAGAMENTO' },
        { text: 'Distribuição', value: 'DISTRIBUICAO' },
        { text: 'Geração', value: 'GERACAO' }
      ],
      modalidadeSelecionada: '',
      classeEnum: [
        { text: 'Residencial', value: 'RESIDENCIAL' },
        { text: 'Rural', value: 'RURAL' },
        { text: 'Iluminação Pública', value: 'ILUMINACAO_PUBLICA' }
      ],
      classeSelecionada: '',
      postoEnum: [
        { text: 'Ponta', value: 'PONTA' },
        { text: 'Fora ponta', value: 'FORA_PONTA' },
        { text: 'Intermediário', value: 'INTERMEDIARIO' }
      ],
      postoSelecionada: '',
      dataInicio: '',
      dataFormatadaInicio: '',
      calendarDataInicio: false,
      updatePickerModalDataInicio: '',
      dataFim: '',
      dataFormatadaFim: '',
      calendarDataFim: false,
      updatePickerModalDataFim: ''
    }
  },
  watch: {
    dataInicio () {
      this.dataFormatadaInicio = moment(this.dataInicio).format('L')
      this.baseTarifariaSelecionada.bt_vigencia_inicio = this.$root.Formatter.parseDate(this.dataFormatadaInicio)
      this.calendarDataInicio = false
    },
    dataFim () {
      this.dataFormatadaFim = moment(this.dataFim).format('L')
      this.baseTarifariaSelecionada.bt_vigencia_fim = this.$root.Formatter.parseDate(this.dataFormatadaFim)
      this.calendarDataFim = false
    }
  },
  methods: {
    async exportXls () {
      this.loadingXls = true
      Api.post('relatorios', {
        headers: this.someHeader(),
        busca: this.searchFinal,
        estado: this.estado,
        cidade: this.cidade,
        type: 'concessionarias'
      })
        .then(res => {
          const baseUrl = window.location.origin
          this.downloadXls(baseUrl + '/' + res.data.url)
          this.removeXls(res.data.url)
          this.loadingXls = false
        })
        .catch(err => {
          console.log(err)
          this.$root.SnackControl.open(this, {
            text: 'Ops, ocorreu um erro ao fazer o donwload!',
            color: 'error'
          })
        })
    },
    async downloadXls (url) {
      const a = document.createElement('a')
      a.href = url
      a.download = url.split('/').pop()
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
    },
    removeXls (url) {
      let data = {
        url: url
      }
      Api.post('relatorios/remove-s3', data)
    },
    exportPdf () {
      this.$root.Printer.openDialog(this, {
        titulo: 'Concessionárias', // Título que aparece centralizado na página e como nome do dialog
        component: RelatorioBase, // componente com o layout a ser impresso
        data: this.dados,
        headers: this.someHeader(), // dados para alimentar o componente, por padrão ele chegará como o props data no componente
        css: `` // Classes css que são adicionados na página de impressão
      })
    },
    someHeader () {
      let cabecalhos = []
      this.headers.map(header => {
        if (header.text !== 'ID' && header.text !== 'Ações' && header.text !== 'Usuários') cabecalhos.push(header)
      })
      return cabecalhos
    },
    loadFunctions () {
      let filters = this.$route.query
      if (filters.estado) this.estado = filters.estado
      if (filters.cidade) this.cidade = filters.cidade
      if (filters.busca) {
        this.search = filters.busca
        this.searchFinal = filters.busca
      }
      this.getConcessionarias()
      this.getEstados()
      this.getCidade()
    },
    limparBusca () {
      this.searchFinal = ''
      this.search = ''
      this.buscaItens()
    },
    buscaItens () {
      this.searchFinal = this.search

      let query = Object.assign({},
        this.searchFinal ? { busca: this.searchFinal } : '',
        this.estado ? { estado: this.estado } : '',
        this.cidade ? { cidade: this.cidade } : ''
      )

      this.$router.replace({name: 'Concessionaria', query: query}).catch(() => {})
    },
    applyFilter () {
      let query = Object.assign({},
        this.searchFinal ? { busca: this.searchFinal } : '',
        this.estado ? { estado: this.estado } : '',
        this.cidade ? { cidade: this.cidade } : ''
      )

      this.$router.replace({name: 'Concessionaria', query: query}).catch(() => {})
      this.dados = []
      this.getConcessionarias()
    },
    async getConcessionarias () {
      this.loading = true
      let filtro = '?filtro='

      if (this.estado) {
        filtro += '&estado=' + this.estado
      }
      if (this.cidade) {
        filtro += '&cidade=' + this.cidade
      }
      await Api.get(`concessionarias${filtro}`)
        .then(res => {
          this.dados = res.data
          this.loading = false
        })
        .catch(err => {
          this.loading = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar as concessionárias!',
            color: 'error'
          })
          console.log(err)
        })
    },
    saveEditConcessionaria () {
      if (!this.$refs.formConcessionaria.validate()) {
        this.$root.SnackControl.open(this, {
          text: 'Por favor, preencha os campos corretamente.',
          color: 'warning'
        })
        return
      }
      this.salvando = true
      let endpoint = 'concessionarias/novo'
      let editado = false
      if (this.concessionaria.uuid_con_id) {
        endpoint = 'concessionarias/edita'
        editado = true
      }

      let cities = []
      if (this.concessionaria.cidades.length) {
        this.concessionaria.cidades.forEach(city => {
          cities.push(city.value)
        })
        this.concessionaria.cidades = cities
      }

      Api.post(endpoint, this.concessionaria)
        .then((response) => {
          this.salvando = false
          if (response.data.error) {
            this.$root.SnackControl.open(this, {
              text: response.data.error,
              color: 'error'
            })
            return false
          }
          this.$root.SnackControl.open(this, {
            text: editado ? 'Concessionária atualizada com sucesso!' : 'Concessionária cadastrada com sucesso!',
            color: 'success'
          })
          this.closeDialog()
          this.getConcessionarias()
        })
        .catch((error) => {
          this.salvando = false
          console.log(error.response)
          this.$root.SnackControl.open(this, {
            text: error.response ? error.response.data.message : 'Ops! Ocorreu um erro!',
            color: 'error'
          })
        })
    },
    removeConcessionaria () {
      this.salvando = true
      Api.delete(`concessionarias/remove/${this.concessionaria.uuid_con_id}`)
        .then(res => {
          this.$root.SnackControl.open(this, {
            text: res.data.message
          })
          this.dialogExcluir = false
          this.salvando = false
          this.closeDialog()
          this.getConcessionarias()
        })
        .catch(err => {
          console.log(err)
          this.salvando = false
          this.$root.SnackControl.open(this, {
            text: err.response ? err.response.data.message : 'Erro ao remover concessionária!',
            color: 'error'
          })
        })
    },
    openNovo (item) {
      this.concessionaria = JSON.parse(JSON.stringify(item))
      this.filterCidadeCadastro(this.concessionaria.con_uf)

      let cities = []
      if (this.concessionaria.cidades.length) {
        this.concessionaria.cidades.forEach(city => {
          cities.push({
            text: city.cci_cidade,
            value: city.cci_cidade
          })
        })
        this.concessionaria.cidades = cities
      }
      this.dialogNovo = true
    },
    openDialogDelete (item) {
      this.concessionaria = JSON.parse(JSON.stringify(item))
      this.dialogExcluir = true
    },
    openDialogDeleteBaseTarifaria (item) {
      this.baseTarifariaEnumSelecionada = item
      this.dialogExcluirBaseTarifaria = true
    },
    async getBasesTarifarias (concessionaria) {
      this.concessionariaSelecionada = concessionaria
      this.loadingBaseTarifaria = true
      let filtro = '?concessionaria=' + concessionaria.uuid_con_id

      if (this.searchFinalBaseTarifaria) {
        filtro += '&busca=' + this.searchFinalBaseTarifaria
      }

      if (this.baseTarifariaEnumSelecionada) {
        filtro += '&base_tarifaria=' + this.baseTarifariaEnumSelecionada
      }

      if (this.modalidadeSelecionada) {
        filtro += '&modalidade=' + this.modalidadeSelecionada
      }

      if (this.classeSelecionada) {
        filtro += '&classe=' + this.classeSelecionada
      }

      if (this.postoSelecionada) {
        filtro += '&posto=' + this.postoSelecionada
      }

      await Api.get(`bases-tarifarias${filtro}`)
        .then(res => {
          this.dadosBaseTarifaria = res.data
          this.loadingBaseTarifaria = false
        })
        .catch(err => {
          this.loadingBaseTarifaria = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar as bases tarifárias!',
            color: 'error'
          })
          console.log(err)
        })
    },
    openBaseTarifaria (item) {
      this.getBasesTarifarias(item)
      this.dialogBaseTarifaria = true
    },
    closeDialogBaseTarifaria () {
      this.dadosBaseTarifaria = []
      this.concessionariaSelecionada = null
      this.baseTarifariaEnumSelecionada = ''
      this.modalidadeSelecionada = ''
      this.classeSelecionada = ''
      this.postoSelecionada = ''
      this.dialogBaseTarifaria = false
    },
    openDialogNovoBaseTarifaria (item) {
      if (item) {
        this.baseTarifariaSelecionada = {...item}

        this.dataInicio = item.bt_vigencia_inicio
        this.dataFormatadaInicio = moment(this.dataInicio).format('L')
        this.baseTarifariaSelecionada.bt_vigencia_inicio = this.$root.Formatter.parseDate(this.dataFormatadaInicio)

        this.dataFim = item.bt_vigencia_fim
        this.dataFormatadaFim = moment(this.dataFim).format('L')
        this.baseTarifariaSelecionada.bt_vigencia_fim = this.$root.Formatter.parseDate(this.dataFormatadaFim)
      }

      this.dialogNovaBaseTarifaria = true
    },
    closeDialogNovoBaseTarifaria () {
      this.baseTarifariaSelecionada = {
        uuid_bt_id: '',
        bt_valor: null,
        bt_vigencia_inicio: null,
        bt_vigencia_fim: null,
        bt_base_tarifaria: null,
        bt_subgrupo: null,
        bt_modalidade: null,
        bt_classe: null,
        bt_subclasse: null,
        bt_detalhe: null,
        bt_acessante: null,
        bt_posto: null,
        bt_componente_tarifaria: null,
        uuid_con_id: null
      }

      this.dialogNovaBaseTarifaria = false
    },
    async saveEditBaseTarifaria () {
      if (!this.$refs.formBaseTarifaria.validate()) {
        this.$root.SnackControl.open(this, {
          text: 'Por favor, preencha os campos corretamente.',
          color: 'warning'
        })
        return
      }
      this.salvando = true
      let endpoint = 'bases-tarifarias/novo'
      let editado = false
      if (this.baseTarifariaSelecionada.uuid_bt_id) {
        endpoint = 'bases-tarifarias/edita'
        editado = true
      }

      this.baseTarifariaSelecionada.uuid_con_id = this.concessionariaSelecionada.uuid_con_id

      Api.post(endpoint, this.baseTarifariaSelecionada)
        .then((response) => {
          this.salvando = false
          if (response.data.error) {
            this.$root.SnackControl.open(this, {
              text: response.data.error,
              color: 'error'
            })
            return false
          }
          this.$root.SnackControl.open(this, {
            text: editado ? 'Base tarifária atualizada com sucesso!' : 'Base tarifária cadastrada com sucesso!',
            color: 'success'
          })
          this.closeDialogNovoBaseTarifaria()
          this.getBasesTarifarias(this.concessionariaSelecionada)
        })
        .catch((error) => {
          this.salvando = false
          this.$root.SnackControl.open(this, {
            text: error.response ? error.response.data.message : 'Ops! Ocorreu um erro!',
            color: 'error'
          })
        })
    },
    async removeBaseTarifaria () {
      this.salvando = true
      Api.delete(`bases-tarifarias/remove/${this.baseTarifariaEnumSelecionada.uuid_bt_id}`)
        .then(res => {
          this.$root.SnackControl.open(this, {
            text: res.data.message
          })
          this.salvando = false
          this.cancelarDeleteBaseTarifaria()
          this.getBasesTarifarias(this.concessionariaSelecionada)
        })
        .catch(err => {
          console.log(err)
          this.salvando = false
          this.$root.SnackControl.open(this, {
            text: err.response ? err.response.data.message : 'Erro ao remover concessionária!',
            color: 'error'
          })
        })
    },
    formatData (data) {
      return moment(data).format('L')
    },
    getEnumValue (enumName, value) {
      if (value) {
        return this[enumName].find(item => item.value === value).text
      }

      return ''
    },
    setCurrencyFormat (value) {
      if (typeof value !== 'number') {
        value = parseFloat(value)
      }

      var formatter = new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL',
        minimumSignificantDigits: 8
      })
      return formatter.format(value)
    },
    cancelarDelete () {
      this.closeDialog()
      this.dialogExcluir = false
    },
    cancelarDeleteBaseTarifaria () {
      this.baseTarifariaSelecionada = {
        uuid_bt_id: '',
        bt_valor: null,
        bt_vigencia_inicio: null,
        bt_vigencia_fim: null,
        bt_base_tarifaria: null,
        bt_subgrupo: null,
        bt_modalidade: null,
        bt_classe: null,
        bt_subclasse: null,
        bt_detalhe: null,
        bt_acessante: null,
        bt_posto: null,
        bt_componente_tarifaria: null,
        uuid_con_id: null
      }
      this.dialogExcluirBaseTarifaria = false
    },
    getEstados () {
      this.loadingEstados = true
      axios.get('https://servicodados.ibge.gov.br/api/v1/localidades/estados?orderBy=nome')
        .then((response) => {
          for (let estado = 0; estado < response.data.length; estado++) {
            this.estados.push({
              text: response.data[estado].nome,
              value: response.data[estado].sigla
            })
          }
        })
        .catch(err => {
          console.log(err)
          this.$root.SnackControl.open(this, {
            text: 'Erro ao buscar os estados!',
            color: 'error'
          })
        })
      this.loadingEstados = false
    },
    getCidade () {
      this.loadingCidades = true
      axios.get('https://servicodados.ibge.gov.br/api/v1/localidades/municipios')
        .then((response) => {
          for (let cidade = 0; cidade < response.data.length; cidade++) {
            this.cidades.push({
              text: response.data[cidade].nome,
              value: response.data[cidade].nome,
              uf: response.data[cidade].microrregiao.mesorregiao.UF.sigla
            })
          }
          if (this.estado) {
            this.cidadesFiltro = this.cidades.filter(city => city.uf === this.estado)
          }
        })
        .catch(err => {
          console.log(err)
          this.$root.SnackControl.open(this, {
            text: 'Erro ao buscar as cidades!',
            color: 'error'
          })
        })
      this.loadingCidades = false
    },
    filterCidade (estado = null) {
      if (!estado) {
        estado = this.estado
        this.cidadesFiltro = this.cidades.filter(city => city.uf === estado)
        this.applyFilter()
      } else {
        this.cidadesFiltradas = this.cidades.filter(city => city.uf === estado)
      }
    },
    filterCidadeCadastro (estado) {
      this.cidadesCadastro = this.cidades.filter(city => city.uf === estado)
    },
    closeDialog () {
      this.concessionaria = {
        con_nome: '',
        con_cnpj: '',
        con_uf: ''
      }
      if (this.$refs.formConcessionaria) {
        this.$refs.formConcessionaria.resetValidation()
      }
      this.dialogNovo = false
    },
    updateData () {
      if (JSON.parse(localStorage.getItem('user')) !== null && !this.user) {
        let user = JSON.parse(localStorage.getItem('user'))
        if (user.fk_gru_id_grupo) {
          this.nivelUsuarioApelido = 'M'
        }
        if (user.fk_dis_id_distribuidor) {
          this.nivelUsuarioApelido = 'D'
        }
        if (user.fk_int_id_integrador) {
          this.nivelUsuarioApelido = 'I'
        }

        if (this.nivelUsuarioApelido !== 'I') {
          this.headers.push({
            text: 'Ações',
            value: 'actions',
            align: 'center',
            sortable: false,
            width: 110
          })
        }
      }
    }
  },
  created () {
    this.updateData()
    this.loadFunctions()
  }
}
</script>

<style lang="scss" scoped>
@import "@scss/_variables.scss";
@import "@scss/_ui.scss";
>>> .v-text-field--outlined .v-input__append-outer, .v-text-field--outlined .v-input__prepend-outer {
  margin-top: 8px!important;
}
.mw_600 {
  max-width: 600px;
}
</style>



// WEBPACK FOOTER //
// src/pages/cadastros/Concessionaria.vue